export default {
  id: 8,
  type: "trash",
  title: "Papelera",
  deleteEntriesAllowed: false,
  adminOnly: true,
  actions: {
    get: "getTrash",
    post: "postTeacher",
    patch: "patchTeacher",
    delete: "deleteTeacher",
  },
  headers: [
    {
      title: "Registro",
      field: {
        name: "record_type",
        type: null,
      },
    },
    {
      title: "Nombre Registro",
      field: {
        name: "record_name",
        type: null,
      },
    },
  ],
  options: [],
  filters: [],
};
